<template>
  <div id="departments">
    <div style="padding: 30px 20px 20px 20px;">
      <vxe-grid v-bind="gridOptions" @cell-dblclick="dbClick">
        
      </vxe-grid>
    </div>
  </div>

</template>

<style scoped>

</style>

<script>
  import axios from "axios";
  export default {
    name: 'workflows',
    data() {
      return {
        gridOptions: {
          keepSource: true,
          resizable: true,
          border: true,
          stripe: true,
          highlightHoverRow: true,
          highlightCurrentRow: true,
          showHeaderOverflow: true,
          showOverflow: true,
          rowId: 'id',
          height: "620",
          size: "small",
          
          classId:[],
          columns: [
          {
            sortable: true,
            field: 'subclassName',
            title: this.$t('message.table.name'),
            width: '25%'
          }, {
            field: 'statusName',
            title: this.$t('message.table.status')
          }],
          data: [],
          editConfig: {
            mode: 'row',
            showIcon: false,
            showStatus: true,
          },
          sortConfig: {
            trigger: 'cell'
          },
        },
      }
    },
    mounted() {},
    methods: {

      getList() {
        this.input_width = this.Global.input_width_small;
        var vm = this;
        axios.get('/ppm/projectStatus/loadTable?tableType=' + 1)
          .then(function (res) {
            console.log(res);
            vm.gridOptions.data = res.data.object.workflows;
            console.log(res);
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      dbClick(row){
        console.log("dbClick");
        console.log(row);
        this.$store.commit("setListId", row.row.subclassId);
        this.$store.commit("setListName", row.row.subclassName);
        this.$router.push("/ppmWorkflowInfo");
      },
      
    },

    created() {
      this.getList();
    }
  };
</script>